<template>
  <div class="foldWrapper">
    <div class="w3-button" @click="toggleContent()">{{labelText}}</div>
    <div v-bind:class="{hidden: contentHidden}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "FoldingContainer",
  data: function() {
    return {
      contentHidden: true
    };
  },
  props: ["labelText"],
  methods: {
    toggleContent: function() {
      this.contentHidden = !this.contentHidden;
    }
  }
};
</script>

<style scoped>
.hidden {
  display: none;
}
</style>
